import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Footer from "../../../components/footer";

const ResultsQuery = (props) => {
    let history = useHistory();

    var date = new Date();

    const _get_all_work_sheets = useSelector((state) => state.work_sheets_module._get_all_work_sheets);

    const [datas, setDatas] = useState([]);

    const dateStart = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-CA');
    const dateEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('en-CA');

    useEffect(() => {
        if (_get_all_work_sheets.data.datos) {
            let v = _get_all_work_sheets.data.datos.filter(x => x.activo === true);
            setDatas(v);
        }
    }, [_get_all_work_sheets]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Hoja de trabajo"
                            items={[{label: "Consulta de resultados", link: "/consulta-resultados"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                            <div className="row mt-1">
                                    <div className="mb-1 col-12">
                                        <div className="pl-1 pr-1 border_card">
                                            <p style={{marginTop: 10, fontSize: 18, color: '#727E8C'}}>Consulta de resultados</p>
                                        </div>
                                    </div>
                                    {datas.length > 0 && (
                                        datas.map((item) => (
                                            <div className="col-md-6 col-12 mb-1">
                                                <div className="d-flex p-1 border_card" style={{cursor: 'pointer'}} onClick={() => {
                                                    history.push(`/resultado/${item.id}/${item.nombre}/0/''/${dateStart}/${dateEnd}`);
                                                }}>
                                                    <div className="d-flex">
                                                        <div className="ml-1">
                                                            <strong className="texto_16">{item.nombre}</strong><br/>
                                                            <strong className="texto_14">Procesos: {item.procesos.length}</strong><br/>
                                                            <span className="texto_14">{item.tipo_usuario}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default ResultsQuery;
